interface QueryParamsBuilderTypes {
  id?: string | number;
  roleName?: string;
  baseUrl: string;
  page?: number;
  size?: number;
  sortBy?: string | undefined;
  sortOrder?: string | undefined;
  searchValue?: string | number | undefined;
  deleted?: boolean;
}

const QueryParamsBuilder = ({
  id,
  roleName,
  baseUrl,
  page,
  size,
  sortBy,
  sortOrder,
  searchValue,
  deleted,
}: QueryParamsBuilderTypes): string => {
  // Base URL
  let apiUrl = id ? `${baseUrl}/${id}` : `${baseUrl}`;

  if (roleName) {
    apiUrl += `/${roleName}`;
  }

  let queryString = `?`;

  if (page) {
    queryString += `page=${page}&`;
  }

  if (size) {
    queryString += `size=${size}&`;
  }

  if (sortBy) {
    queryString += `sortBy=${sortBy}&`;
  }

  if (sortOrder) {
    queryString += `sortOrder=${sortOrder}&`;
  }

  if (searchValue) {
    queryString += `searchValue=${searchValue}&`;
  } else {
    queryString += `searchValue=&`;
  }

  if (queryString.endsWith('&')) {
    queryString = queryString.slice(0, -1);
  }

  apiUrl += queryString;

  return apiUrl;
};

export default QueryParamsBuilder;
